import styled from "styled-components";
import { colors } from "../../../utils";

const Wrapper = styled.button`
		background-color: ${(props) => {
			switch (props.type) {
				case "warning":
					return colors.info
				case "primary":
					return colors.primary
				case "success":
					return colors.success
				case "danger":
					return colors.danger
				default:
					return "white"
			}
		}};
		
		outline: none;
		border-radius: 999px;
		transition: .2s all;
		font-weight: 600;
		font-family: inherit;
		padding: calc(6px + .2vw) calc(12px + 1vw);
		font-size: inherit;
		text-align: center;
		border: none;

		&:not(:disabled) {
			&:hover,
			&:focus
			 {
				cursor: pointer;
				color: #2e0d93;
				box-shadow: 0px 0px 20px ${(props) => {
					switch (props.type) {
						case "warning":
							return colors.info
						case "primary":
							return colors.primary
						case "success":
							return colors.success
						case "danger":
							return colors.danger
						default:
							return "white"
					}
				}};
			}
		}
	`

export default Wrapper
